


import { Error, ExpandLess, ExpandMore, Facebook, Instagram, LinkedIn, Twitter } from '@mui/icons-material';
import { Accordion, AccordionActions, AccordionDetails, AccordionSummary, Autocomplete, IconButton, InputAdornment } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { PurpleButton } from '../../components/mui/Buttons';
import { TextInput } from '../../components/mui/Inputs';
import { PrimaryText, SecondaryText } from '../../components/mui/Typography';

import '../../styling/portal.css'



export default function PortalEdit({}) {

    const [open1,setOpen1] = useState(true)
    const [open2,setOpen2] = useState(false)
    const [open3,setOpen3] = useState(false)
    const [open4,setOpen4] = useState(false)


    const [businessName,setBusinessName] = useState("Global Fitness")
    const [address,setAddress] = useState("23 Neagh Road, Terenure")
    const [city,setCity] = useState("Dublin")
    const [country,setCountry] = useState("Morocco")

    const [contactName,setContactName] = useState("")
    const [contactEmail,setContactEmail] = useState("")
    const [contactPhone,setContactPhone] = useState("")


    const [facebookText,setFacebookText] = useState("")
    const [instagramText,setInstagramText] = useState("")
    const [twitterText,setTwitterText] = useState("")
    const [linkedInText,setLinkedInText] = useState("")

    

    const countryOptions = [ "Afghanistan", "Albania", "Algeria", "American Samoa", "Andorra", "Angola", "Anguilla", "Antarctica", "Antigua and Barbuda", "Argentina", "Armenia", "Aruba", "Australia", "Austria", "Azerbaijan", "Bahamas (the)", "Bahrain", "Bangladesh", "Barbados", "Belarus", "Belgium", "Belize", "Benin", "Bermuda", "Bhutan", "Bolivia (Plurinational State of)", "Bonaire, Sint Eustatius and Saba", "Bosnia and Herzegovina", "Botswana", "Bouvet Island", "Brazil", "British Indian Ocean Territory (the)", "Brunei Darussalam", "Bulgaria", "Burkina Faso", "Burundi", "Cabo Verde", "Cambodia", "Cameroon", "Canada", "Cayman Islands (the)", "Central African Republic (the)", "Chad", "Chile", "China", "Christmas Island", "Cocos (Keeling) Islands (the)", "Colombia", "Comoros (the)", "Congo (the Democratic Republic of the)", "Congo (the)", "Cook Islands (the)", "Costa Rica", "Croatia", "Cuba", "Curaçao", "Cyprus", "Czechia", "Côte d'Ivoire", "Denmark", "Djibouti", "Dominica", "Dominican Republic (the)", "Ecuador", "Egypt", "El Salvador", "Equatorial Guinea", "Eritrea", "Estonia", "Eswatini", "Ethiopia", "Falkland Islands (the) [Malvinas]", "Faroe Islands (the)", "Fiji", "Finland", "France", "French Guiana", "French Polynesia", "French Southern Territories (the)", "Gabon", "Gambia (the)", "Georgia", "Germany", "Ghana", "Gibraltar", "Greece", "Greenland", "Grenada", "Guadeloupe", "Guam", "Guatemala", "Guernsey", "Guinea", "Guinea-Bissau", "Guyana", "Haiti", "Heard Island and McDonald Islands", "Holy See (the)", "Honduras", "Hong Kong", "Hungary", "Iceland", "India", "Indonesia", "Iran (Islamic Republic of)", "Iraq", "Ireland", "Isle of Man", "Israel", "Italy", "Jamaica", "Japan", "Jersey", "Jordan", "Kazakhstan", "Kenya", "Kiribati", "Korea (the Democratic People's Republic of)", "Korea (the Republic of)", "Kuwait", "Kyrgyzstan", "Lao People's Democratic Republic (the)", "Latvia", "Lebanon", "Lesotho", "Liberia", "Libya", "Liechtenstein", "Lithuania", "Luxembourg", "Macao", "Madagascar", "Malawi", "Malaysia", "Maldives", "Mali", "Malta", "Marshall Islands (the)", "Martinique", "Mauritania", "Mauritius", "Mayotte", "Mexico", "Micronesia (Federated States of)", "Moldova (the Republic of)", "Monaco", "Mongolia", "Montenegro", "Montserrat", "Morocco", "Mozambique", "Myanmar", "Namibia", "Nauru", "Nepal", "Netherlands (the)", "New Caledonia", "New Zealand", "Nicaragua", "Niger (the)", "Nigeria", "Niue", "Norfolk Island", "Northern Mariana Islands (the)", "Norway", "Oman", "Pakistan", "Palau", "Palestine, State of", "Panama", "Papua New Guinea", "Paraguay", "Peru", "Philippines (the)", "Pitcairn", "Poland", "Portugal", "Puerto Rico", "Qatar", "Republic of North Macedonia", "Romania", "Russian Federation (the)", "Rwanda", "Réunion", "Saint Barthélemy", "Saint Helena, Ascension and Tristan da Cunha", "Saint Kitts and Nevis", "Saint Lucia", "Saint Martin (French part)", "Saint Pierre and Miquelon", "Saint Vincent and the Grenadines", "Samoa", "San Marino", "Sao Tome and Principe", "Saudi Arabia", "Senegal", "Serbia", "Seychelles", "Sierra Leone", "Singapore", "Sint Maarten (Dutch part)", "Slovakia", "Slovenia", "Solomon Islands", "Somalia", "South Africa", "South Georgia and the South Sandwich Islands", "South Sudan", "Spain", "Sri Lanka", "Sudan (the)", "Suriname", "Svalbard and Jan Mayen", "Sweden", "Switzerland", "Syrian Arab Republic", "Taiwan", "Tajikistan", "Tanzania, United Republic of", "Thailand", "Timor-Leste", "Togo", "Tokelau", "Tonga", "Trinidad and Tobago", "Tunisia", "Turkey", "Turkmenistan", "Turks and Caicos Islands (the)", "Tuvalu", "Uganda", "Ukraine", "United Arab Emirates (the)", "United Kingdom of Great Britain and Northern Ireland (the)", "United States Minor Outlying Islands (the)", "United States of America (the)", "Uruguay", "Uzbekistan", "Vanuatu", "Venezuela (Bolivarian Republic of)", "Viet Nam", "Virgin Islands (British)", "Virgin Islands (U.S.)", "Wallis and Futuna", "Western Sahara", "Yemen", "Zambia", "Zimbabwe", "Åland Islands" ];


    const validateLink = (linkText) => {
        let url;
        try {
            url = new URL(linkText);
        } catch (_) {
            return false;
        }
        return url.protocol === "http:" || url.protocol === "https:";
    }

    const formatPrice = () => {
        console.log("PRICE",contactPhone)
        setContactPhone((+contactPhone).toFixed(2))
    }

    return(

        <div className="portalEditScreen">
            <div className='fullScreen'>
                <div className='container'>
                    
                    <div className='portalEditContent'>

                        <div className="passOverviewHeaders">
                            <PrimaryText variant="h3">YOUR LISTING</PrimaryText>
                            <SecondaryText variant="subtitle1">Make changes and additions to your listing below</SecondaryText>
                        </div>


                        <Accordion TransitionProps={{ unmountOnExit: true }} expanded={open1}>
                            <AccordionSummary onClick={()=>setOpen1(!open1)}>
                                <div className='portalEditBlockTop'>
                                    <div>
                                        <PrimaryText variant='h4'>General Info</PrimaryText>
                                        {open1 && <SecondaryText variant='subtitle2'>Help users know where to find you</SecondaryText>}
                                    </div>
                                    
                                    {open1 && <ExpandLess />}
                                    {!open1 && <ExpandMore />}
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                
                                <div className='portalEditSec1Content'>
                                    <div className='portalEditRow'>

                                    
                                        <div className='portalEditColumn'>
                                        
                                            <div className='portalEditSubtitles'>
                                                <SecondaryText variant='subtitle1'>Basic Info</SecondaryText>
                                                <SecondaryText variant='subtitle2'>Help users know where to find you</SecondaryText>
                                            </div>
                                            
                                            <TextInput className='portalEditInput' variant="outlined" label="Business Name"
                                                value={businessName} onChange={(e) => setBusinessName(e.target.value)}/>
                                            
                                            <TextInput className='portalEditInput' variant="outlined" label="Address"
                                                value={address} onChange={(e) => setAddress(e.target.value)}/>

                                            <TextInput className='portalEditInput' variant="outlined" label="City"
                                                value={city} onChange={(e) => setCity(e.target.value)}/>

                                            <Autocomplete className='portalEditCountry' disablePortal options={countryOptions} renderInput={(params)=><TextInput {...params} variant="outlined" label="Country" value={country} defaultValue={country}/>} onChange={(e) => setCountry(e.target.textContent)}/>

                                            
                                        </div>
                                        <div className='portalEditColumn'>
                                            <div className='portalEditSubtitles'>
                                                <SecondaryText variant='subtitle1'>Contact Information</SecondaryText>
                                                <SecondaryText variant='subtitle2'>This will NOT appear on your profile</SecondaryText>
                                            </div>

                                            <TextInput className='portalEditInput' variant="outlined" label="Contact Name"
                                                value={contactName} onChange={(e) => setContactName(e.target.value)}/>

                                            <TextInput className='portalEditInput' variant="outlined" label="Contact Email"
                                                value={contactEmail} onChange={(e) => setContactEmail(e.target.value)}/>

                                            <TextInput className='portalEditInput' variant="outlined" label="Contact Phone Number"
                                                value={contactPhone} onChange={(e) => setContactPhone(e.target.value)}/>
                                        </div>

                                     </div>

                                     <div className='portalEditColumn'>
                                            <div className='portalEditSubtitles'>
                                                <SecondaryText variant='subtitle1'>Pass Information</SecondaryText>
                                                <SecondaryText variant='subtitle2'>What short term passes do you offer for visitors?</SecondaryText>
                                            </div>

                                            <div className='portalEditPassRow'>
                                                <TextInput className='portalEditInput' variant="outlined" label="Pass Name"
                                                    placeholder='1 Day Gym Pass'
                                                    value={contactName} onChange={(e) => setContactName(e.target.value)}/>

                                                <TextInput className='portalEditInput'variant="outlined" label="Duration (Days)"
                                                    placeholder='1'
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                          event.preventDefault();
                                                        }
                                                      }}
                                                    value={contactEmail} onChange={(e) => setContactEmail(e.target.value)}/>

                                                <TextInput className='portalEditInput' variant="outlined" label="Price (€)"
                                                type="number" onBlur={formatPrice}
                                                    value={contactPhone} onChange={(e) => setContactPhone((e.target.value))}/>
                                            </div>
                                            
                                            <div className='portalEditPassRow'>
                                                <TextInput className='portalEditInput' variant="outlined" label="Pass Name"
                                                    value={contactName} onChange={(e) => setContactName(e.target.value)}/>

                                                <TextInput className='portalEditInput'variant="outlined" label="Duration (Days)"
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                          event.preventDefault();
                                                        }
                                                      }}
                                                    value={contactEmail} onChange={(e) => setContactEmail(e.target.value)}/>

                                                <TextInput className='portalEditInput' variant="outlined" label="Price (€)"
                                                type="number" onBlur={formatPrice}
                                                    value={contactPhone} onChange={(e) => setContactPhone((e.target.value))}/>
                                            </div>

                                        </div>

                                </div>

                                
                            </AccordionDetails>

                            <AccordionActions>
                                <PurpleButton size='medium'>SAVE</PurpleButton>
                            </AccordionActions>

                        </Accordion>






                        <Accordion TransitionProps={{ unmountOnExit: true }} expanded={open2}>
                            <AccordionSummary onClick={()=>setOpen2(!open2)}>
                                <div className='portalEditBlockTop'>
                                    <PrimaryText variant='h4'>Images</PrimaryText>
                                    {open2 && <ExpandLess />}
                                    {!open2 && <ExpandMore />}
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div>Content</div>
                                <div>Content</div>
                                <div>Content</div>
                                <div>Content</div>
                                <div>Content</div>
                                <div>Content</div>
                            </AccordionDetails>

                            <AccordionActions>
                                <PurpleButton size='medium'>SAVE</PurpleButton>
                            </AccordionActions>

                        </Accordion>





                        <Accordion TransitionProps={{ unmountOnExit: true }} expanded={open3}>
                            <AccordionSummary onClick={()=>setOpen3(!open3)}>
                                <div className='portalEditBlockTop'>
                                    <PrimaryText variant='h4'>Social Media</PrimaryText>
                                    {open3 && <ExpandLess />}
                                    {!open3 && <ExpandMore />}
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div className='portalEditColumn'>

                                
                                <TextInput 
                                    type="text" 
                                    error={facebookText.length>0 && !validateLink(facebookText)}
                                    helperText={(facebookText.length>0 && !validateLink(facebookText))?"Invalid Link":""}
                                    variant="outlined" 
                                    label="Facebook URL"
                                    placeholder='https://facebook.com'
                                    value={facebookText} onChange={(e) => setFacebookText(e.target.value)}
                                    InputProps={{ // <-- This is where the toggle button is added.
                                        startAdornment: (
                                            <InputAdornment position="start">
                                                <Facebook />
                                            </InputAdornment>
                                            ),
                                        endAdornment: (
                                        <InputAdornment position="end">
                                            <IconButton>
                                                {(facebookText.length>0 && !validateLink(facebookText)) && <Error className="inputErrorIcon"/>}
                                            </IconButton>
                                        </InputAdornment>
                                        )
                                    }}
                                    />

                                    <TextInput 
                                        type="text" 
                                        error={instagramText.length>0 && !validateLink(instagramText)}
                                        helperText={(instagramText.length>0 && !validateLink(instagramText))?"Invalid Link":""}
                                        variant="outlined" 
                                        label="Instagram URL"
                                        placeholder='https://instagram.com'
                                        value={instagramText} onChange={(e) => setInstagramText(e.target.value)}
                                        InputProps={{ // <-- This is where the toggle button is added.
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Instagram />
                                                </InputAdornment>
                                                ),
                                            endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    {(instagramText.length>0 && !validateLink(instagramText)) && <Error className="inputErrorIcon"/>}
                                                </IconButton>
                                            </InputAdornment>
                                            )
                                        }}
                                    />

                                    <TextInput 
                                        type="text" 
                                        error={twitterText.length>0 && !validateLink(twitterText)}
                                        helperText={(twitterText.length>0 && !validateLink(twitterText))?"Invalid Link":""}
                                        variant="outlined" 
                                        label="Twitter URL"
                                        placeholder='https://twitter.com'
                                        value={twitterText} onChange={(e) => setTwitterText(e.target.value)}
                                        InputProps={{ // <-- This is where the toggle button is added.
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <Twitter />
                                                </InputAdornment>
                                                ),
                                            endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    {(twitterText.length>0 && !validateLink(twitterText)) && <Error className="inputErrorIcon"/>}
                                                </IconButton>
                                            </InputAdornment>
                                            )
                                        }}
                                    />

                                    <TextInput 
                                        type="text" 
                                        error={linkedInText.length>0 && !validateLink(linkedInText)}
                                        helperText={(linkedInText.length>0 && !validateLink(linkedInText))?"Invalid Link":""}
                                        variant="outlined" 
                                        label="LinkedIn URL"
                                        placeholder='https://linkedin.com'
                                        value={linkedInText} onChange={(e) => setLinkedInText(e.target.value)}
                                        InputProps={{ // <-- This is where the toggle button is added.
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    <LinkedIn />
                                                </InputAdornment>
                                                ),
                                            endAdornment: (
                                            <InputAdornment position="end">
                                                <IconButton>
                                                    {(linkedInText.length>0 && !validateLink(linkedInText)) && <Error className="inputErrorIcon"/>}
                                                </IconButton>
                                            </InputAdornment>
                                            )
                                        }}
                                    />
                                    </div>

                                    
                            </AccordionDetails>

                            <AccordionActions>
                                <PurpleButton size='medium'>SAVE</PurpleButton>
                            </AccordionActions>

                        </Accordion>





                        <Accordion TransitionProps={{ unmountOnExit: true }} expanded={open4}>
                            <AccordionSummary onClick={()=>setOpen4(!open4)}>
                                <div className='portalEditBlockTop'>
                                    <PrimaryText variant='h4'>Facility Info</PrimaryText>
                                    {open4 && <ExpandLess />}
                                    {!open4 && <ExpandMore />}
                                </div>
                            </AccordionSummary>
                            <AccordionDetails>
                                <div>Content</div>
                                <div>Content</div>
                                <div>Content</div>
                                <div>Content</div>
                                <div>Content</div>
                                <div>Content</div>
                            </AccordionDetails>

                            <AccordionActions>
                                <PurpleButton size='medium'>SAVE</PurpleButton>
                            </AccordionActions>

                        </Accordion>



                    </div>

                
                </div>
            </div>
        </div>
    )
}